import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  canonicalPath?: string;
  jsonLd?: Record<string, unknown>[];
}

export default function Seo({ title, description, canonicalPath = "/", jsonLd = [] }: SeoProps) {
  useEffect(() => {
    document.title = title;

    let desc: HTMLMetaElement | null = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.name = "description";
      document.head.appendChild(desc);
    }
    desc.content = description;

    let keywords: HTMLMetaElement | null = document.querySelector('meta[name="keywords"]');
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      document.head.appendChild(keywords);
    }
    keywords.content = "吃瓜网上,吃瓜网上今日热点,吃瓜网上全网汇总,吃瓜网上热门事件,今日热点,全网热点";

    let canonical: HTMLLinkElement | null = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `${window.location.origin}${window.location.pathname}`;

    // OG / Twitter
    const ogTags: Record<string, string> = {
      "og:title": title,
      "og:description": description,
      "og:type": "website",
      "og:url": window.location.href,
      "og:site_name": "吃瓜网上",
      "twitter:card": "summary_large_image",
      "twitter:title": title,
      "twitter:description": description,
    };
    Object.entries(ogTags).forEach(([prop, content]) => {
      let meta: HTMLMetaElement | null = document.querySelector(`meta[property="${prop}"],meta[name="${prop}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(prop.startsWith("og:") ? "property" : "name", prop);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", content);
    });

    // structured data
    const scriptId = "page-jsonld";
    document.querySelectorAll(`#${scriptId}`).forEach((s) => s.remove());
    if (jsonLd.length) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description]);

  return null;
}